"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollYourOwnSetting = void 0;
var RollYourOwnSetting;
(function (RollYourOwnSetting) {
    RollYourOwnSetting[RollYourOwnSetting["DISABLED"] = 0] = "DISABLED";
    RollYourOwnSetting[RollYourOwnSetting["FIRST"] = 1] = "FIRST";
    RollYourOwnSetting[RollYourOwnSetting["ALWAYS"] = 2] = "ALWAYS";
})(RollYourOwnSetting || (exports.RollYourOwnSetting = RollYourOwnSetting = {}));
//# sourceMappingURL=RollYourOwnSetting.js.map